<template>
  <v-card class="trezo-card bg-white border-0 shadow-none border-radius mb-0">
    <div class="v-card-header">
      <h5 class="mb-0">Soru Sayısı (Zaman Serisi)</h5>
    </div>
    <div class="p-3">
      <div v-if="!timeseries.labels.length" class="text-muted py-4 text-center">
        Veri bulunamadı
      </div>
      <apexchart
        v-else
        type="area"
        height="280"
        :options="chartOptions"
        :series="timeseries.series"
      />
    </div>
  </v-card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ApexOptions } from 'apexcharts'
import type { TimeSeries } from '@/services/adminStatsApi'

const props = defineProps<{ timeseries: TimeSeries }>()

const chartOptions = computed<ApexOptions>(() => ({
  chart: { toolbar: { show: false }, zoom: { enabled: false } },
  stroke: { curve: 'smooth', width: 2 },
  colors: ['#3b82f6', '#10b981'],
  fill: {
    type: 'gradient',
    gradient: { opacityFrom: 0.35, opacityTo: 0.0, shadeIntensity: 1 },
  },
  dataLabels: { enabled: false },
  xaxis: {
    categories: props.timeseries.labels,
    tickAmount: 8,
    labels: { rotate: -30, style: { fontSize: '11px' } },
  },
  yaxis: [
    { labels: { formatter: (v: number) => Math.round(v).toString() }, title: { text: 'Soru' } },
    { opposite: true, labels: { formatter: (v: number) => Math.round(v).toString() }, title: { text: 'Kullanıcı' } },
  ],
  legend: { position: 'top' },
  tooltip: { shared: true, intersect: false },
}))
</script>
